import React, { Component } from 'react';
import { Container } from 'components';
import { fetchErrorLogs } from 'api';
import ReactTable from 'react-table';
import ErrorLogsContainerHOC from './ErrorLogsContainerHOC';

const default_page_size = 20;

class ErrorLogsContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      table_data: [],
      size: default_page_size,
      total: 0,
      offset: 0,
      loading: true
    };

    this.handlePageSizeChange = this.handlePageSizeChange.bind(this);
    this.handlePageIndexChange = this.handlePageIndexChange.bind(this);
  }

  handlePageSizeChange(page_size, page_index) {
    this.setState({ loading: true });
    fetchErrorLogs({ sort: { prop_name: 'timestamp', order: 'desc' }, size: page_size, offset: page_index })
    .then(data => {
      this.setState({
        table_data: data.results.map(d => ({ timestamp: d.timestamp, error: d.meta })),
        total: data.total,
        offset: page_index,
        size: page_size,
        loading: false
      });
    })
    .catch(e => {
      console.log(e);
      this.setState({ loading: false });
    });
  }
  handlePageIndexChange(page_index) {
    this.setState({ loading: false });
    fetchErrorLogs({ sort: { prop_name: 'timestamp', order: 'desc' }, size: this.state.size, offset: page_index })
    .then(data => {
      this.setState({
        table_data: data.results.map(d => ({ timestamp: d.timestamp, error: d.meta })),
        offset: page_index,
        total: data.total,
        loading: false
      });
    })
    .catch(e => {
      console.log(e);
      this.setState({ loading: false });
    });
  }

  componentWillMount() {
    fetchErrorLogs({ sort: { prop_name: 'timestamp', order: 'desc' }, size: default_page_size })
    .then(data => {
      this.setState({
        table_data: data.results.map(d => ({ timestamp: d.timestamp, error: d.meta })),
        total: data.total,
        loading: false
      });
    })
    .catch(e => {
      this.setState({ loading: false });
      console.log(e);
    });
  }

  render() {
    const { columns } = this.props;
    const { total, size } = this.state;
    const pages = total % size == 0 ? parseInt(total / size) : (parseInt(total / size) + 1);

    return (
      <Container title='Error Logs'>
        <div className='error-logs-container'>
          <ReactTable
            manual
            data={this.state.table_data}
            columns={columns}
            page={this.state.offset}
            pageSize={this.state.size}
            loading={this.state.loading}
            defaultPageSize={default_page_size}
            onPageSizeChange={this.handlePageSizeChange}
            onPageChange={this.handlePageIndexChange}
            pages={pages}
          />
        </div>
      </Container>
    );
  }
}

export default ErrorLogsContainerHOC(ErrorLogsContainer);



// WEBPACK FOOTER //
// ./src/browser/components/error-logs/ErrorLogsContainer.js